import { useTranslation } from 'react-i18next';

import { faCheckCircle } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { I18NextNS } from 'src/models/Language.model';

import StatusCardTemplate from './StatusCardTemplate';

export default function GradableStatusCard() {
  const { t } = useTranslation(I18NextNS.PAGES, {
    keyPrefix: 'newExam.analyzingModal.statusCards.gradable',
  });

  return (
    <StatusCardTemplate
      icon={<FontAwesomeIcon icon={faCheckCircle} className="text-success" />}
      iconBackgroundColor="success-100"
      primaryText={t('primary')}
      secondaryText={t('secondary')}
      dataTest="status-gradable"
    />
  );
}
